import { render } from "./ForgotPasswordVerifyView.vue?vue&type=template&id=3a05813e&scoped=true"
import script from "./ForgotPasswordVerifyView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerifyView.vue?vue&type=script&lang=js"

import "./ForgotPasswordVerifyView.vue?vue&type=style&index=0&id=3a05813e&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a05813e"]])

export default __exports__